import * as Yup from 'yup';

export const schema = Yup.object({
	cat_tax_regimes_id: Yup.mixed().required(),
	curp: Yup.string().nullable(true).matches(new RegExp(`^[A-Z]{1}[AEIOU]{1}[A-Z]{2}[0-9]{2}(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1])[HM]{1}(AS|BC|BS|CC|CS|CH|CL|CM|DF|DG|GT|GR|HG|JC|MC|MN|MS|NT|NL|OC|PL|QT|QR|SP|SL|SR|TC|TS|TL|VZ|YN|ZS|NE)[B-DF-HJ-NP-TV-Z]{3}[0-9A-Z]{1}[0-9]{1}$`), {excludeEmptyString: true}),
	employer_registration: Yup.string().nullable(true).min(10),
	business_name: Yup.string().nullable(true).min(3),
	cat_payment_forms_id: Yup.mixed().required(),
	cat_payment_methods_id: Yup.mixed().required(),
	cat_usoscfdi_id: Yup.mixed().required(),
	customs: Yup.mixed().notRequired().default(1),
	cat_currencies_id: Yup.mixed().required(),
	decimals: Yup.number().notRequired().positive().integer().min(0).max(6).default(2),
});
